import Loader from '@components/Loader/Loader';
import PhaseBanner from '@components/sentinel/PhaseBanner/PhaseBanner';
import ProcessActions from '@components/sentinel/ProcessActions/ProcessActions';
import usePageId from '@hooks/usePageId';
import { usePageScroll } from '@hooks/usePageScroll';
import { useSentinelGuard } from '@hooks/useSentinelGuard';
import { useEffect } from 'react';
import { useAppSelector } from 'universal-scripts';
import DetectionStep from './steps/DetectionStep/DetectionStep';
import ResponseStep from './steps/ResponseStep/ResponseStep';
import VerificationStep from './steps/VerificationStep/VerificationStep';

import './ProcessView.css';

export default function ProcessView() {
	usePageId('sentinel-process');
	const { isReady } = useSentinelGuard();
	const { scrollToElement } = usePageScroll();
	const currentPhase = useAppSelector((state) => state.sentinel.currentPhase);
	const status = useAppSelector((state) => state.sentinel.status);

	useEffect(() => {
		if (status === 'completed') {
			scrollToElement('action-suggestions');
		} else if (currentPhase === 'verify' || currentPhase === 'respond') {
			scrollToElement(currentPhase);
		}
	}, [currentPhase, status, scrollToElement]);

	if (!isReady) {
		return <Loader />;
	}

	return (
		<div id="process-view">
			<PhaseBanner />
			<section id="detect" className="process-section">
				<DetectionStep />
			</section>
			<section id="verify" className="process-section">
				<VerificationStep />
			</section>
			<section id="respond" className="process-section">
				<ResponseStep />
			</section>
			<ProcessActions />
		</div>
	);
}
